import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * getUsedSpaceForecast
 *
 * @private
 */
export const getUsedSpaceForecast = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.order.GetUsedSpaceForecastResult['result'],
  // First argument to the payload creator
  uui.domain.actions.rpc.order.GetUsedSpaceForecastAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/order/getUsedSpaceForecast', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/order/getUsedSpaceForecast', {
      category: 'rpc',
      type: 'rpc/order/getUsedSpaceForecast',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on getUsedSpaceForecast`,
      { tags: ['rpc', 'order'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `getUsedSpaceForecast call failed`,
      error,
    })
  }
})
